import React, { useState, useEffect } from "react";
import HeaderPost from '../blog/HeaderPost';
import Footer from "../components/Footer";
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { MinusSmallIcon, PlusSmallIcon } from '@heroicons/react/24/outline'
import {  ChevronRightIcon } from "@heroicons/react/24/solid";
import { Link } from 'react-router-dom';
import { CurrencyEuroIcon } from "@heroicons/react/16/solid";
import AccompagnementClotere from '../components/AccompagnementClotere'
import PrendreRdv from "../leadPage/prendreRdv";


const faqs = [
  {
    question: "Qu'est-ce qu'un contrat de mariage ?",
    answer:
      "Le contrat de mariage est un acte notarié signé avant le mariage qui permet aux futurs époux de choisir leur régime matrimonial.\n\nIl définit les règles de gestion, de propriété et de partage des biens du couple, pendant le mariage et en cas de séparation ou de décès.",
  },
  {
    question: "Est-il obligatoire de faire un contrat de mariage ?",
    answer:
      "Non, le contrat de mariage n’est pas obligatoire.\n\nSi les époux ne signent aucun contrat, ils seront automatiquement soumis au régime légal : la communauté réduite aux acquêts.\n\nUn contrat devient utile si vous souhaitez organiser différemment la gestion ou la séparation des biens.",
  },
  {
    question: "Quels sont les principaux types de contrats de mariage ?",
    answer:
      "Il existe plusieurs types de contrats :\n\n• La séparation de biens : chaque époux reste propriétaire de ses biens, présents et futurs.\n• La communauté universelle : tous les biens deviennent communs, présents et futurs.\n• La participation aux acquêts : séparation de biens durant le mariage, mais partage des gains en cas de dissolution.\n• La communauté réduite aux acquêts avec aménagements : possibilité d’y ajouter des clauses spécifiques.",
  },
  {
    question: "Quel est le coût d’un contrat de mariage ?",
    answer:
      "Le tarif dépend de la complexité du contrat et des éventuels apports intégrés.\n\nEn moyenne :\n• Contrat simple : entre 350 € et 500 € TTC.\n• Avec apports importants : les frais proportionnels s’ajoutent selon un barème dégressif (environ 400 € à 1000 € en fonction des montants).\n\nDes frais de débours et la TVA viennent également s’ajouter.",
  },
  {
    question: "Peut-on faire un contrat de mariage après le mariage ?",
    answer:
      "Oui, il est possible de modifier ou mettre en place un contrat de mariage après le mariage.\n\nCette démarche nécessite un acte notarié et une homologation par un juge si le couple a des enfants mineurs ou majeurs protégés.\n\nUn délai de 2 ans de mariage est exigé avant toute modification.",
  },
  {
    question: "Un contrat de mariage protège-t-il les biens personnels ?",
    answer:
      "Oui, notamment dans le cadre d’une séparation de biens.\n\nLes biens acquis avant le mariage ainsi que ceux reçus par donation ou héritage restent la propriété personnelle de chaque époux.\n\nCela protège également les patrimoines personnels en cas de dettes contractées par l’autre époux.",
  },
  {
    question: "Le contrat de mariage est-il valable à l’international ?",
    answer:
      "Un contrat de mariage rédigé en France est juridiquement valable sur le territoire français.\n\nÀ l’étranger, la reconnaissance dépend de la législation locale.\n\nPour les couples binationaux ou vivant à l’international, il est recommandé d’établir un contrat avec une clause de loi applicable et de vérifier les règles du pays de résidence.",
  },
  {
    question: "Peut-on inclure des clauses spécifiques dans un contrat de mariage ?",
    answer:
      "Oui, il est possible d'ajouter des clauses personnalisées.\n\nExemples :\n• Clause de préciput : pour attribuer certains biens à l’un des époux en cas de décès.\n• Clause d’exclusion de certains biens de la communauté.\n• Donations ou avantages matrimoniaux.\n\nUn notaire vous aidera à adapter ces clauses à votre situation.",
  },
  {
    question: "Comment choisir le bon régime matrimonial ?",
    answer:
      "Le choix dépend de plusieurs facteurs :\n• La situation patrimoniale des époux.\n• La présence d’enfants issus d’une précédente union.\n• Les risques professionnels ou patrimoniaux.\n• Le souhait de protéger son conjoint en cas de décès.\n\nUn rendez-vous avec un notaire est conseillé pour bien comprendre les implications de chaque régime.",
  },
  {
    question: "Que se passe-t-il en cas de divorce avec un contrat de mariage ?",
    answer:
      "Le contrat de mariage détermine les règles de partage des biens en cas de divorce.\n\n• En séparation de biens : chacun récupère ses biens personnels.\n• En communauté : les biens communs sont partagés à parts égales.\n\nLe contrat peut également contenir des clauses visant à protéger l’un des époux ou à faciliter la séparation.",
  },
];

export default function NotaryFeesCalculator() {
  const [apport, setApport] = useState(100000);
  const [result, setResult] = useState(null);

  const calculateFees = () => {
    let total = 0;
    const tranches = [
      { min: 0, max: 6500, rate: 0.01935 },
      { min: 6500, max: 17000, rate: 0.01064 },
      { min: 17000, max: 60000, rate: 0.00726 },
      { min: 60000, max: Infinity, rate: 0.00532 },
    ];

    for (let tranche of tranches) {
      if (apport > tranche.min) {
        const montantTranche = Math.min(apport, tranche.max) - tranche.min;
        total += montantTranche * tranche.rate;
      }
    }

    const fraisFixes = 369; // Exemple
    const tva = 0.2;
    const totalHT = fraisFixes + total;
    const totalTTC = totalHT * (1 + tva);

    setResult({
      fraisFixes,
      fraisProportionnels: total.toFixed(2),
      tvaMontant: (totalHT * tva).toFixed(2),
      totalTTC: totalTTC.toFixed(2),
    });
  };
  useEffect(() => {
    calculateFees(apport);
  }, []);
  return (
    <>
      <HeaderPost titre="Calculateur prix contrat de mariage" breadlink1="/outils/notaire" namelink1="Outils" namelinkActive="Calculateur prix contrat de mariage" />

      <div className="container">
        {/** calculateur */}
        <section className="">
          <div className="flex flex-col sm:flex-row gap-16 items-center flex-wrap">
            <div className="flex-1">
              <div className="mb-8">
                <label className="block text-lg font-medium mb-1">Montant des apports des époux</label>
                <label className="block text-xs font-medium mb-1 text-gray-500">Les apports sont les biens immobiliers et/ou sommes d'argent</label>
                <div className="mt-2 grid grid-cols-1">
                <input
                  type="number"
                  placeholder="Ex : 250 000€"
                  value={apport}
                  onChange={(e) => setApport(Number(e.target.value))}
                  className="input-clotere col-start-1 row-start-1 block w-full rounded-md bg-white py-3 text-xl pr-10 pl-3  text-gray-900 outline-1 -outline-offset-1 outline-gray-300 placeholder:text-gray-400 focus:outline-2 focus:-outline-offset-2 focus:outline-indigo-600 sm:pr-9 sm:text-sm/6"
                />
                <CurrencyEuroIcon
          aria-hidden="true"
          className="pointer-events-none col-start-1 row-start-1 mr-3 size-5 self-center justify-self-end text-gray-400 sm:size-4"
        /></div>
              </div>


              <button className="w-full bg-indigo-600 text-white py-2 rounded-lg hover:bg-indigo-700 transition" onClick={calculateFees}>
                Calculer le prix
              </button>
            </div>

            <div className="flex-1">
              <div className="p-4 bg-gray-50 rounded-lg text-sm text-gray-700">
                <div className="bg-slate-100 p-12 rounded-lg text-center">
                  <p className="font-medium mb-2">Prix de votre contrat de mariage estimé </p>
                  <p className="font-bold text-5xl text-indigo-800">{result ? `${result.totalTTC} €` : "-- €"} </p>
                </div>

                <div className="border-t border-gray-300">
                  <dl className="divide-y divide-gray-300">
                    <div className="p-3 sm:grid sm:grid-cols-2 items-center">
                      <dt className="text-sm font-medium text-gray-700 items-center flex"><span className="text-indigo-600 text-3xl">•</span> Frais fixe</dt>
                      <dd className="mt-1 text-xl font-bold  sm:mt-0">369€</dd>
                    </div>
                    <div className="p-3 sm:grid sm:grid-cols-2 items-center">
                      <dt className="text-sm font-medium text-gray-700 items-center flex"><span className="text-orange-600 text-3xl">•</span> Frais proportionnels</dt>
                      <dd className="mt-1 text-xl font-bold  sm:mt-0">{result ? `${result.fraisProportionnels} €` : "-- €"} </dd>
                    </div>
                    <div className="p-3 sm:grid sm:grid-cols-2 items-center">
                      <dt className="text-sm font-medium text-gray-700 items-center flex"><span className="text-yellow-600 text-3xl">•</span> TVA 20%</dt>
                      <dd className="mt-1 text-xl font-bold  sm:mt-0">{result ? `${result.tvaMontant} €` : "-- €"}</dd>
                    </div>
                  </dl>
                </div>
              </div>
            </div>

          </div>
        </section>

        {/** 3 informations clés */}
        <section className="mt-10">
          <div>
            <dl className="space-y-16 sm:grid sm:grid-cols-2 sm:gap-x-6 sm:space-y-0 sm:gap-y-16 lg:grid-cols-3 lg:gap-x-10">
              <div className="bg-indigo-800 text-white rounded-md p-4 flex flex-col justify-around">
                <dt className="text-base/7 font-semibold">Dans quelles situations prévoir un contrat de mariage ?</dt>
                <dd className="mt-2 text-base/7">Opter pour un contrat de mariage permet d’anticiper certaines situations et d’adapter le régime matrimonial aux besoins spécifiques des époux. Que ce soit pour protéger le conjoint en cas de décès, anticiper une éventuelle séparation ou faire face à un changement de situation professionnelle, ce contrat offre de nombreux avantages.</dd>
                <a href="https://clotere.framer.website/blog/dans-quelles-situations-prevoir-un-contrat-de-mariage" target="blank" className=" text-white">En savoir plus</a>
              </div>
              <div className="bg-indigo-800 text-white rounded-md p-4 flex flex-col justify-around">
                <dt className="text-base/7 font-semibold">Quelles sont les étapes pour établir un contrat de mariage chez le notaire ?</dt>
                <dd className="mt-2 text-base/7">Pour organiser au mieux la gestion de vos biens pendant le mariage, et anticiper les conséquences d'un divorce ou d'un décès, il est possible d'établir un contrat de mariage. Ce document, rédigé par un notaire, permet de choisir un régime matrimonial adapté à votre situation. Voici les étapes clés pour établir un contrat de mariage.</dd>
                <a href="https://clotere.framer.website/blog/les-%C3%A9tapes-pour-%C3%A9tablir-un-contrat-de-mariage" target="blank" className=" text-white">En savoir plus</a>
              </div>
              <div className="bg-purple-800 text-white rounded-md p-4 flex flex-col justify-around">
                <dt className="text-base/7 font-semibold">Bon à savoir</dt>
                <dd className="mt-2 text-base/7">Clotere.fr vous permet de réaliser votre contrat de mariage de manière transparente avec des étapes simples : 
                <ul className="p-0">
                  <li className="items-center flex font-bold"><ChevronRightIcon className="text-white size-4"/> Choisissez votre notaire</li>
                  <li className="items-center flex font-bold"><ChevronRightIcon className="text-white size-4"/> Déposez vos documents</li>
                  <li className="items-center flex font-bold"><ChevronRightIcon className="text-white size-4"/> Echangez avec votre notaire</li>
                  <li className="items-center flex font-bold"><ChevronRightIcon className="text-white size-4"/> Fixez simplement votre rendez-vous de signature</li>
                  <li className="items-center flex font-bold"><ChevronRightIcon className="text-white size-4"/> Posez toutes vos questions à votre conseiller dédié Clotere</li>
                  </ul>
                  </dd>
                <Link to="/onboard/mariage" className=" text-white">Débutez votre dossier</Link>
              </div>
            </dl>
          </div>
        </section>

        {/** CTA */}
        <div className="">
          <div className="mx-auto max-w-7xl px-6 py-16 lg:flex lg:items-center lg:justify-between lg:px-8 rounded-xl bg-indigo-50 mt-10">
            <div>
              <h2 className="max-w-2xl text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                Vous souhaitez faire un contrat de mariage ?
              </h2>
              <p>Clotere, vous met en relation avec des notaires disponibles et <br/>vous accompagne de A à Z dans la constitution de votre dossier.</p>
            </div>
            <div className="mt-10 flex items-center gap-x-6 lg:mt-0 lg:shrink-0">
              <Link
                to="/onboard/mariage"
                className="no-underline rounded-md bg-indigo-600 px-3.5 py-2.5 text-sm font-semibold text-white shadow-xs hover:bg-indigo-500 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
              >
                Debuter mon contrat de mariage
              </Link>
              <a href="https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ2N3sMiWCWTD3GWAp9oN-FoJEdzm42kuKNeR0ZTFdXc1V4UG5DSezuPQXlFiGHvzrwOZKPcJbjL" target="blank" className="text-sm/6 font-semibold text-gray-900">
                Prendre rendez-vous <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        </div>

        {/** accompagnement */}
        <AccompagnementClotere/>

        {/** FAQ */}
        <section className="mt-10">
          <div className="bg-white">
            <div className="mx-auto max-w-7xl px-6  lg:px-8 ">
              <div className="mx-auto max-w-4xl">
                <h2 className="text-4xl font-semibold tracking-tight text-gray-900 sm:text-5xl">
                  Questions les plus fréquentes au sujet du contrat de mariage
                </h2>
                <dl className="mt-16 divide-y divide-gray-900/10">
                  {faqs.map((faq) => (
                    <Disclosure key={faq.question} as="div" className="py-6 first:pt-0 last:pb-0">
                      <dt>
                        <DisclosureButton className="group flex w-full items-start justify-between text-left text-gray-900">
                          <span className="text-base/7 font-semibold">{faq.question}</span>
                          <span className="ml-6 flex h-7 items-center">
                            <PlusSmallIcon aria-hidden="true" className="size-6 group-data-open:hidden" />
                            <MinusSmallIcon aria-hidden="true" className="size-6 group-not-data-open:hidden" />
                          </span>
                        </DisclosureButton>
                      </dt>
                      <DisclosurePanel as="dd" className="mt-2 pr-12">
                        <p className="text-base/7 text-gray-600">{faq.answer}</p>
                      </DisclosurePanel>
                    </Disclosure>
                  ))}
                </dl>
              </div>
            </div>
          </div>
        </section>
        
      </div>
      <br/>
      <PrendreRdv/>

      <Footer/>
    </>
  );
}
